import React, { useEffect } from 'react';
// import { DrawerBody } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { DateTime } from 'luxon';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { getWindow } from '../../../utils/general';
import '../../../styles/drawer.scss';
import { useCommonContext, useExperienceContext, } from '../../../hooks/useContexts';
export var RescheduleDeliverySurvey = function (_a) {
    var _b, _c, _d;
    var orderId = _a.orderId, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, orderDetailsData = _a.orderDetailsData, customerType = _a.customerType, firstDay = _a.firstDay, newRescheduleDay = _a.newRescheduleDay;
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isMobile = useCommonContext().isMobile;
    useEffect(function () {
        var timerId = setTimeout(function () {
            var _a, _b, _c, _d, _e;
            if (((_a = getWindow()) === null || _a === void 0 ? void 0 : _a.QSI) && ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.QSI.API)) {
                (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.QSI.API.unload();
                (_d = getWindow()) === null || _d === void 0 ? void 0 : _d.QSI.API.load();
                (_e = getWindow()) === null || _e === void 0 ? void 0 : _e.QSI.API.run();
            }
        }, 100);
        return function () { return clearTimeout(timerId); };
    }, []);
    var deliveryData = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) !== null && _b !== void 0 ? _b : (_d = (_c = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _c === void 0 ? void 0 : _c.bodfsDeliveries) === null || _d === void 0 ? void 0 : _d[0];
    var oldDeliveryDateForResch = typeof firstDay === 'string'
        ? DateTime.fromISO(firstDay).toFormat('yyyy-LL-dd')
        : undefined;
    var newDeliveryDateForResch = typeof newRescheduleDay === 'string'
        ? DateTime.fromISO(newRescheduleDay).toFormat('yyyy-LL-dd')
        : undefined;
    var checkDeliveryTrackerStatus = function () {
        var trackerData = fulfillmentGroup.deliveryTrackerData;
        // Type guard: check if 'status' exists
        if (trackerData && 'status' in trackerData) {
            if (trackerData.status === 'MISSED_WITH_ATTEMPT' ||
                trackerData.status === 'MISSED_WITHOUT_ATTEMPT' ||
                trackerData.status === 'MISSED_WITHOUT_ENROUTE') {
                return trackerData.status;
            }
        }
        return 'DELIVERY_NOT_MISSED';
    };
    var renderSurvey = function () {
        var _a, _b, _c, _d, _e, _f;
        return (React.createElement("div", null,
            React.createElement("input", { type: "hidden", id: "orderNumberForResch", value: orderId }),
            React.createElement("input", { type: "hidden", id: "orderOriginForResch", value: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderOrigin }),
            React.createElement("input", { type: "hidden", id: "fulfillmentTypeForResch", value: fulfillmentType }),
            React.createElement("input", { type: "hidden", id: "saleDateForResch", value: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.salesDate }),
            React.createElement("input", { type: "hidden", id: "customerTypeForResch", value: customerType }),
            React.createElement("input", { type: "hidden", id: "appXPForResch", value: isConsumerApp ? 'true' : 'false' }),
            React.createElement("input", { type: "hidden", id: "siteXPForResch", value: isMobile ? 'mobile' : 'desktop' }),
            React.createElement("input", { type: "hidden", id: "deliveryCityForResch", value: (_b = (_a = deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.deliveryAddress) === null || _a === void 0 ? void 0 : _a.postalDetails) === null || _b === void 0 ? void 0 : _b.city }),
            React.createElement("input", { type: "hidden", id: "deliveryStateForResch", value: (_d = (_c = deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.deliveryAddress) === null || _c === void 0 ? void 0 : _c.postalDetails) === null || _d === void 0 ? void 0 : _d.state }),
            React.createElement("input", { type: "hidden", id: "deliveryZipForResch", value: (_f = (_e = deliveryData === null || deliveryData === void 0 ? void 0 : deliveryData.deliveryAddress) === null || _e === void 0 ? void 0 : _e.postalDetails) === null || _f === void 0 ? void 0 : _f.zipCode }),
            React.createElement("input", { type: "hidden", id: "oldDeliveryDateForResch", value: oldDeliveryDateForResch }),
            React.createElement("input", { type: "hidden", id: "newDeliveryDateForResch", value: newDeliveryDateForResch }),
            React.createElement("input", { type: "hidden", id: "missedDeliveryForResch", value: checkDeliveryTrackerStatus() }),
            React.createElement("div", { id: "rescheduleXPsurvey", className: "sui-block" })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "sui-pb-2" },
            React.createElement(AlertBanner, { status: "success" },
                "Your delivery has been successfully rescheduled.",
                ' ')),
        React.createElement("div", null,
            React.createElement(ErrorBoundary, { name: "reschedule-delivery-survey" }, renderSurvey()))));
};
